module.exports = __webpack_public_path__ + "static/Benz.a0bb1581.png";